AOS.init();

const navbar = document.querySelector('.hero__navbar');
const toggle = document.querySelector('.hero__toggle');
const menu = document.querySelector('.hero__menu');

if (navbar) {
    window.addEventListener('scroll', () => {
        navbar.classList.toggle('hero__navbar--scrolled', window.scrollY > 20);
    });
}

if (toggle && menu) {
    toggle.addEventListener('click', () => {
        const isOpen = menu.classList.toggle('hero__menu--open');
        toggle.classList.toggle('hero__toggle--open', isOpen);
        toggle.setAttribute('aria-expanded', String(isOpen));
        toggle.setAttribute('aria-label', isOpen ? 'Fechar menu' : 'Abrir menu');
    });

    menu.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', () => {
            menu.classList.remove('hero__menu--open');
            toggle.classList.remove('hero__toggle--open');
            toggle.setAttribute('aria-expanded', 'false');
            toggle.setAttribute('aria-label', 'Abrir menu');
        });
    });
}
